module.exports = __webpack_public_path__ + "img/img_sld.a4857cf8.png";